package us.laantech.admin.menu.clients.ads.ui

import androidx.compose.foundation.Image
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.produceState
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import androidx.compose.ui.layout.ContentScale
import io.github.kdroidfilter.composemediaplayer.InitialPlayerState
import io.github.kdroidfilter.composemediaplayer.VideoPlayerSurface
import io.github.kdroidfilter.composemediaplayer.rememberVideoPlayerState
import io.ktor.http.Url
import us.laantech.admin.menu.clients.ads.LocalAdConfigViewModel
import org.jetbrains.skia.Image as SkiaImage

// The caller owns sizing via `modifier` (thumbnails pass a fixed aspect box; the preview passes
// fillMaxSize). `contentScale` controls how the media fills that box: Crop for edge-to-edge
// thumbnails, Fit for the preview so nothing is cropped when the window resizes.
@Composable
fun S3Preview(
    s3Url: String,
    modifier: Modifier = Modifier,
    autoPlay: Boolean = false,
    contentScale: ContentScale = ContentScale.Fit,
) {

    val viewModel = LocalAdConfigViewModel.current
    val fileName = Url(s3Url).segments.lastOrNull().orEmpty()
    val isVideo = fileName.endsWith(".mp4", ignoreCase = true)

    if (isVideo) {
        // When autoPlay is set, play the video (looping continuously); otherwise load it
        // paused on its first frame so it reads as a thumbnail. The player fetches the URL
        // itself (no auth header), so the presigned S3 URL works directly and only the
        // needed bytes are buffered.
        val playerState = rememberVideoPlayerState()
        LaunchedEffect(s3Url, autoPlay) {
            playerState.loop = autoPlay
            playerState.openUri(
                s3Url,
                if (autoPlay) InitialPlayerState.PLAY else InitialPlayerState.PAUSE,
            )
        }
        VideoPlayerSurface(
            playerState = playerState,
            modifier = modifier,
            contentScale = contentScale,
            // no `overlay` = no controls
        )
    } else {
        // Fetch the bytes off the presigned URL and decode with skia.
        val bitmap by produceState<ImageBitmap?>(null, s3Url) {
            value = runCatching {
                viewModel.fetchBytes(s3Url)?.let {
                    SkiaImage.makeFromEncoded(it).toComposeImageBitmap()
                }
            }.getOrNull()
        }
        bitmap?.let {
            Image(
                bitmap = it,
                contentDescription = fileName,
                modifier = modifier,
                contentScale = contentScale,
            )
        }
    }

}